import React from 'react';
import ClientJobCard from './ClientJobCard';

function ClientJobList({ jobs, loading, error, emptyMessage = 'No jobs found.', onJobChanged }) {
  if (loading) {
    return <div className="rounded-3xl bg-white p-8 text-center text-slate-600 shadow-sm">Loading jobs...</div>;
  }

  if (error) {
    return <div className="rounded-3xl bg-rose-50 p-8 text-center text-rose-700 shadow-sm">Error: {error}</div>;
  }

  if (!jobs || jobs.length === 0) {
    return <div className="rounded-3xl bg-white p-8 text-center text-slate-500 shadow-sm">{emptyMessage}</div>;
  }

  return (
    <div className="space-y-4">
      {jobs.map((job) => (
        <ClientJobCard key={job.id} job={job} onJobChanged={onJobChanged} />
      ))}
    </div>
  );
}

export default ClientJobList;
